export default __webpack_public_path__ + "7f3e68778a4cb6a70e0c994135d7774b.png";